export default __webpack_public_path__ + "static/media/3.3e31c12d.png";